<template>
  <div class="hc-global-header-tool-right">
    <a href="http://www.hc.cn" target="_blank" style="color: inherit">
      <span class="hc-global-header-tool-action">
        <a-icon type="question-circle" />
      </span>
    </a>

    <screenfull id="screenfull" class="hc-global-header-tool-action" />

    <notice-icon class="hc-global-header-tool-action" />

    <user-account-dropdown class="hc-global-header-tool-action" />
  </div>
</template>

<script>
import Screenfull from '@/components/Screenfull'
import NoticeIcon from '@/components/GlobalHeader/NoticeIcon'
import UserAccountDropdown from '@/components/GlobalHeader/AvatarDropdown'
import projectConfig from '@/config/projectConfig'

export default {
  name: 'GlobalHeaderToolRight',
  components: {
    NoticeIcon,
    Screenfull,
    UserAccountDropdown,
  },
  data() {
    return {
      enableI18n: projectConfig.enableI18n,
    }
  },
  methods: {},
}
</script>
